import { lazy, Suspense, type ComponentProps } from 'react';

const SettingsPanelImpl = lazy(() => import('./SettingsPanelImpl'));
type SettingsPanelProps = ComponentProps<typeof SettingsPanelImpl>;

/** Keep settings-only controls out of the initial arcade bundle. */
export default function SettingsPanel(props: SettingsPanelProps) {
  return (
    <Suspense fallback={<div role="status">Loading settings…</div>}>
      <SettingsPanelImpl {...props} />
    </Suspense>
  );
}
